import { JonumVerifiedDialog } from '#src/components/jonum/JonumVerifiedDialog/index.tsx';

import { JonumAccountLockedDialog } from './JonumAccountLockedDialog.tsx';
import { JonumGracePeriodWarningDialog } from './JonumGracePeriodWarningDialog.tsx';

export const JonumStatusDialogs = () => (
  <>
    <JonumVerifiedDialog />
    <JonumGracePeriodWarningDialog />
    <JonumAccountLockedDialog />
  </>
);
